import { IQuiz } from '@sdk/contracts';
import { Button, Popover } from 'antd';
import { useNavigate } from 'react-router-dom';

import { Content } from './Content';
import { Wrapper } from './QuizzesActions.styled';

import { Icon } from '@/components/Icon';
import { useProfile } from '@/store';
import { buildQuizUrl } from '@/utils';

type Props = {
  quiz: IQuiz;
  isFromBaseContent?: boolean;
};

export const QuizzesActions: React.FC<Props> = ({ quiz, isFromBaseContent }) => {
  const {
    roleCheck: { isInspector }
  } = useProfile();

  const navigateTo = useNavigate();

  if (isInspector) return null;

  return (
    <Wrapper>
      <Button
        size="large"
        type="text"
        icon={<Icon i="Edit" />}
        onClick={(e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
          e.stopPropagation();
          const quizId = quiz.parentBaseQuiz ?? quiz._id;
          navigateTo(buildQuizUrl({ quizId, isFromBaseContent }));
        }}
      />

      <Popover placement="right" content={<Content quiz={quiz} />}>
        <Button
          size="large"
          type="text"
          icon={<Icon i="OverflowMenuVertical" />}
          onClick={(e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => e.stopPropagation()}
        />
      </Popover>
    </Wrapper>
  );
};
